import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import client, { urlFor } from "../output/sanityClient";
import bgImage from "../assets/bg1.jpg";

const categories = [
  "all",
  "bathroom",
  "exterior",
  "interior",
  "kitchen",
  "repair",
];

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState(["all"]);
  const [modalOpen, setModalOpen] = useState(false); // To control modal visibility
  const [selectedImage, setSelectedImage] = useState(null); // To store the selected image

  useEffect(() => {
    client
      .fetch('*[_type == "gallery"]{image, subtitle, category}')
      .then((data) => {
        setImages(data);
      })
      .catch(console.error);
  }, []);

  const handleCategoryChange = (category) => {
    setSelectedCategories(category === "all" ? ["all"] : [category]);
  };

  const openModal = (image) => {
    setSelectedImage(image); // Set the clicked image
    setModalOpen(true); // Open the modal
  };

  const closeModal = () => {
    setModalOpen(false); // Close the modal
    setSelectedImage(null); // Clear the selected image
  };

  const filteredImages = selectedCategories.includes("all")
    ? images
    : images.filter((image) => selectedCategories.includes(image.category));

  return (
    <div>
      <motion.div
        className="relative h-96 bg-cover bg-center"
        style={{ backgroundImage: `url(${bgImage})` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="absolute inset-0 bg-[#000000] bg-opacity-10 flex items-center justify-center flex-col">
          <motion.h1
            className="text-[#fcc11b] text-4xl font-bold mb-4"
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            Finished Projects
          </motion.h1>
        </div>
      </motion.div>

      <div className="container mx-auto px-4 py-8">
        <h2 className="text-4xl font-bold mb-4 text-center">Finished Projects</h2>
        <div className="flex flex-wrap justify-center mb-8">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => handleCategoryChange(category)}
              className={`px-4 py-2 m-2 rounded ${
                selectedCategories.includes(category)
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 text-gray-700"
              }`}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {filteredImages.map((image, index) => (
            <motion.div
              key={index}
              className="border"
              whileHover={{
                scale: 1.1,
                boxShadow: "0px 20px 30px rgba(0, 0, 0, 0.4)",
                transition: { duration: 0.2 },
              }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <img
                src={urlFor(image.image).width(500).url()}
                alt={`Gallery ${index}`}
                className="w-full h-48 sm:h-64 object-cover cursor-pointer"
                onClick={() => openModal(image)} 
              />
            </motion.div>
          ))}
        </div>
      </div>
      {modalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={closeModal} 
        >
          <div
            className="relative p-4 backdrop-blur-sm "
            onClick={(e) => e.stopPropagation()} 
          >
            <img
              src={urlFor(selectedImage.image).width(1000).url()}
              alt="Full view"
              className="max-w-full max-h-screen object-contain mx-10 my-10 py-10"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
